import { render, staticRenderFns } from "./modal-menu-detail.vue?vue&type=template&id=32eeba12&scoped=true&"
import script from "./modal-menu-detail.vue?vue&type=script&lang=js&"
export * from "./modal-menu-detail.vue?vue&type=script&lang=js&"
import style0 from "./modal-menu-detail.vue?vue&type=style&index=0&id=32eeba12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32eeba12",
  null
  
)

export default component.exports